/**
 * Created by lihanying on 2017/7/14.
 */
import React from 'react'
import { Table, Input } from 'antd'
import './style.css'

class EditableCell extends React.Component {
  state = {
    inputValue: '',
    editable: this.props.editable || false,
  }

  componentDidMount() {
    this.setState({
      inputValue: this.props.value,
    })
  }

  handleChange(e) {
    const value = e.target.value
    this.setState(
      {
        inputValue: value,
      },
      () => {
        this.props.onChange(value)
      }
    )
  }

  render() {
    const { value, editable } = this.props
    const { inputValue } = this.state
    return (
      <div>
        {editable ? (
          <div>
            <Input value={inputValue} onChange={(e) => this.handleChange(e)} />
          </div>
        ) : (
          <div className="editable-row-text">
            {value ? value.toString() : ''}
          </div>
        )}
      </div>
    )
  }
}

export default EditableCell



// WEBPACK FOOTER //
// ./src/containers/ClubMember/component/editableCell.js